export default __webpack_public_path__ + "static/media/analytics-download-vector.614c5d22.svg";